/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PagedModelRequest } from './pagedModelRequest';
import { CodeViewModel } from './codeViewModel';
import { PagedListMetaData } from './pagedListMetaData';

export interface CodeViewModelPagedModelResponse {
  pagedRequest?: PagedModelRequest;
  data?: Array<CodeViewModel> | null;
  metaData?: PagedListMetaData;
}
